<div class="media-box p-2">
  <div class="media-box-body">
    <h5 class="media-box-heading"><em class="fas fa-tags"></em> Available: {{summary.available | number}}</h5>
    <small class="text-muted">
      <span class="text-nowrap">Test Codes: {{summary.testCodes | number}}</span> |
      <span class="text-nowrap">Awarded Today: {{summary.awardedToday | number}}</span> |
      <span class="text-nowrap">Imported Today: {{summary.importedToday | number}}</span>
    </small>
  </div>
</div>
